module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Regular.49c56da.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Regular.otf
// module id = kKmy
// module chunks = 0